// @ts-nocheck
/**
 * chat-fetch.js — XHR-based fetch wrapper for the AI Florist chat.
 *
 * Shopify's analytics script (shop_events_listener) replaces window.fetch
 * before our code runs, routing all requests through their event collector
 * and causing CORS failures on localhost. XMLHttpRequest is NOT intercepted
 * by Shopify's wrapper, so we use it for all Worker API calls.
 *
 * Exposes: window.AIFlorist.fetch(url, options) → Promise<Response-like>
 */
(function () {
  'use strict';

  window.AIFlorist = window.AIFlorist || {};

  function isLocalDebugHost() {
    var host = window.location && window.location.hostname;
    return host === 'localhost' || host === '127.0.0.1';
  }

  function buildDebugLogger(level) {
    return function () {
      if (!isLocalDebugHost()) return;
      if (!window.console || typeof window.console[level] !== 'function') return;
      window.console[level].apply(window.console, arguments);
    };
  }

  window.AIFlorist.debug = window.AIFlorist.debug || {
    enabled: isLocalDebugHost(),
    log: buildDebugLogger('log'),
    warn: buildDebugLogger('warn'),
    error: buildDebugLogger('error'),
  };

  /**
   * fetch() replacement using XMLHttpRequest.
   * Returns a Response-like object with .ok, .status, .json(), .text().
   *
   * @param {string} url
   * @param {object} [options]
   * @param {string} [options.method]
   * @param {object} [options.headers]
   * @param {string} [options.body]
   * @param {AbortSignal} [options.signal]
   * @returns {Promise<{ok: boolean, status: number, statusText: string, json: function, text: function}>}
   */
  window.AIFlorist.fetch = function nativeFetch(url, options) {
    options = options || {};
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', url, true);

      if (options.headers) {
        Object.keys(options.headers).forEach(function (key) {
          xhr.setRequestHeader(key, options.headers[key]);
        });
      }

      if (options.signal) {
        options.signal.addEventListener('abort', function () {
          xhr.abort();
        });
      }

      xhr.onload = function () {
        resolve({
          ok: xhr.status >= 200 && xhr.status < 300,
          status: xhr.status,
          statusText: xhr.statusText,
          json: function () {
            return Promise.resolve(JSON.parse(xhr.responseText));
          },
          text: function () {
            return Promise.resolve(xhr.responseText);
          },
        });
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        var err = new Error('The operation was aborted.');
        err.name = 'AbortError';
        reject(err);
      };

      xhr.send(options.body || null);
    });
  };
})();
